import api from './api';

export const searchProjects = async (searchCriteria) => {
  try {
    // Use GET method with query parameters for pagination following admin module pattern
    const { page, limit, ...otherCriteria } = searchCriteria;
    
    // If we have search criteria other than pagination, use POST
    const hasSearchCriteria = Object.values(otherCriteria).some(value => 
      value !== undefined && value !== null && value !== ''
    );
    
    let response;
    if (hasSearchCriteria) {
      // POST with search criteria in body and pagination in query
      response = await api.post(`/search?page=${page || 1}&limit=${limit || 10}`, otherCriteria);
    } else {
      // GET with only pagination parameters
      response = await api.get(`/search?page=${page || 1}&limit=${limit || 10}`);
    }
    
    // Transform admin module response format to match frontend expectations
    const result = response.data;
    return {
      data: result.data || [],
      pagination: {
        currentPage: result.currentPage,
        totalPages: result.totalPages,
        totalItems: result.totalItems,
        itemsPerPage: result.itemsPerPage,
        hasNextPage: result.currentPage < result.totalPages,
        hasPreviousPage: result.currentPage > 1
      }
    };
  } catch (error) {
    console.error('Search error:', error);
    throw error;
  }
};

export default searchProjects;
